import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function Bases() {
  const [bases, setBases] = useState([
    { id: 1, name: '北京职业体验基地', city: '北京', address: '北京市朝阳区xxx', contact: '张老师', phone: '138****8001', activities: 24, students: 1560, status: 'active' },
    { id: 2, name: '上海科技馆基地', city: '上海', address: '上海市浦东新区xxx', contact: '李老师', phone: '138****8002', activities: 18, students: 980, status: 'active' },
    { id: 3, name: '深圳自然教育基地', city: '深圳', address: '深圳市南山区xxx', contact: '王老师', phone: '138****8003', activities: 12, students: 560, status: 'active' },
  ])
  const [showModal, setShowModal] = useState(false)
  const [selectedBase, setSelectedBase] = useState(null)
  const [form, setForm] = useState({ name: '#999', city: '#999', address: '#999', contact: '#999', phone: '' })

  useEffect(() => { loadBases() }, [])

  const loadBases = () => {
    fetch(`${API}/bases`)
      .then(r => r.json())
      .then(d => { if (d.success && d.data && d.data.length > 0) setBases(d.data) })
      .catch(() => console.log('使用演示数据'))
  }

  const handleSave = () => {
    if (!form.name || !form.city) { alert('请填写基地名称和城市'); return }
    if (selectedBase) {
      setBases(prev => prev.map(b => b.id === selectedBase.id ? { ...b, ...form } : b))
      alert(`基地 "${form.name}" 已更新`)
    } else {
      setBases(prev => [...prev, { id: Date.now(), ...form, activities: 0, students: 0, status: 'active' }])
      alert(`基地 "${form.name}" 创建成功`)
    }
    setShowModal(false)
    setSelectedBase(null)
    setForm({ name: '#999', city: '#999', address: '#999', contact: '#999', phone: '' })
  }

  const handleEdit = (base) => {
    setSelectedBase(base)
    setForm({ name: base.name, city: base.city, address: base.address || '', contact: base.contact || '', phone: base.phone || '' })
    setShowModal(true)
  }

  const handleDelete = (base) => {
    if (confirm(`确定删除基地 "${base.name}" 吗？`)) {
      setBases(prev => prev.filter(b => b.id !== base.id))
      alert('基地已删除')
    }
  }

  const resetPassword = (base) => {
    if (!confirm(`确定重置 ${base.phone || base.name} 的密码？`)) return
    const tempPwd = Math.random().toString(36).slice(-8)
    alert(`新密码：${tempPwd}\n请告知基地负责人并提醒修改密码`)
  }

  const toggleStatus = (base) => {
    const newStatus = base.status === 'active' ? 'disabled' : 'active'
    if (!confirm(`确定${newStatus === 'active' ? '启用' : '禁用'}基地 ${base.name}？`)) return
    setBases(prev => prev.map(b => b.id === base.id ? { ...b, status: newStatus } : b))
    alert('状态已更新')
  }

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h2 style={{ fontSize: 20, marginBottom: 4 }}>🏢 基地管理</h2>
          <p style={{ color: '#666', fontSize: 13 }}>管理活动基地，基地可发布活动到总部审核</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={() => { window.location.assign('/cms/?page=base-register'); }} style={{ padding: '12px 24px', background: '#722ed1', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}>
            📝 基地申请
          </button>
          <button onClick={() => { setSelectedBase(null); setForm({ name: '', city: '', address: '', contact: '', phone: '' }); setShowModal(true) }} style={{ padding: '12px 24px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}>
            + 新建基地
          </button>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>基地总数</div><div style={{ fontSize: 28, color: '#1890ff' }}>{bases.length}</div></div>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>活动总数</div><div style={{ fontSize: 28, color: '#52c41a' }}>{bases.reduce((s, b) => s + b.activities, 0)}</div></div>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>覆盖学员</div><div style={{ fontSize: 28, color: '#fa8c16' }}>{bases.reduce((s, b) => s + (b.students || 0), 0).toLocaleString()}</div></div>
        <div style={card}><div style={{ color: '#999', fontSize: 12 }}>本月活动</div><div style={{ fontSize: 28, color: '#722ed1' }}>28</div></div>
      </div>

      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#fafafa' }}>
              <th style={th}>基地名称</th>
              <th style={th}>城市</th>
              <th style={th}>地址</th>
              <th style={th}>联系人</th>
              <th style={th}>活动</th>
              <th style={th}>学员</th>
              <th style={th}>状态</th>
              <th style={th}>操作</th>
            </tr>
          </thead>
          <tbody>
            {bases.map(b => (
              <tr key={b.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={td}><span style={{ fontWeight: 500 }}>{b.name}</span></td>
                <td style={{ ...td, color: '#666' }}>{b.city}</td>
                <td style={{ ...td, color: '#999', fontSize: 12 }}>{b.address || '-'}</td>
                <td style={{ ...td, color: '#666' }}>{b.contact || '-'}</td>
                <td style={{ ...td, color: '#1890ff' }}>{b.activities}</td>
                <td style={{ ...td, color: '#52c41a' }}>{(b.students || 0).toLocaleString()}</td>
                <td style={td}><span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: b.status === 'active' ? '#f6ffed' : '#fff1f0', color: b.status === 'active' ? '#52c41a' : '#ff4d4f' }}>{b.status === 'active' ? '运营中' : '已停用'}</span></td>
                <td style={td}>
                  <button onClick={() => handleEdit(b)} style={{ ...btn, background: '#1890ff', color: '#fff' }}>编辑</button>
                  <button onClick={() => resetPassword(b)} style={{ ...btn, background: '#faad14', color: '#fff', marginLeft: 4 }}>重置密码</button>
                  <button onClick={() => toggleStatus(b)} style={{ ...btn, background: b.status === 'active' ? '#ff4d4f' : '#52c41a', color: '#fff', marginLeft: 4 }}>{b.status === 'active' ? '禁用' : '启用'}</button>
                  <button onClick={() => handleDelete(b)} style={{ ...btn, background: '#8c8c8c', color: '#fff', marginLeft: 4 }}>删除</button>
                  <button onClick={() => window.dispatchEvent(new CustomEvent('navigate', { detail: 'studybase-approval' }))} style={{ ...btn, background: '#722ed1', color: '#fff', marginLeft: 4 }}>活动</button>
                  <button onClick={() => handleDelete(b)} style={{ ...btn, background: '#ff4d4f', color: '#fff', marginLeft: 4 }}>删除</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div style={modalOverlay} onClick={() => setShowModal(false)}>
          <div style={modalContent} onClick={e => e.stopPropagation()}>
            <h3 style={{ marginBottom: 20 }}>{selectedBase ? '编辑基地' : '新建基地'}</h3>
            <div style={{ display: 'grid', gap: 16 }}>
              <div>
                <label style={label}>基地名称 *</label>
                <input value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="请输入基地名称" style={input} />
              </div>
              <div>
                <label style={label}>城市 *</label>
                <input value={form.city} onChange={e => setForm({...form, city: e.target.value})} placeholder="请输入城市" style={input} />
              </div>
              <div>
                <label style={label}>详细地址</label>
                <input value={form.address} onChange={e => setForm({...form, address: e.target.value})} placeholder="请输入详细地址" style={input} />
              </div>
              <div>
                <label style={label}>联系人</label>
                <input value={form.contact} onChange={e => setForm({...form, contact: e.target.value})} placeholder="请输入联系人姓名" style={input} />
              </div>
              <div>
                <label style={label}>联系电话</label>
                <input value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} placeholder="请输入联系电话" style={input} />
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 24 }}>
              <button onClick={() => setShowModal(false)} style={{ ...btn, background: '#f5f5f5', color: '#666' }}>取消</button>
              <button onClick={handleSave} style={{ ...btn, background: '#1890ff', color: '#fff' }}>保存</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

const card = { background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }
const th = { padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }
const td = { padding: 12, fontSize: 13 }
const btn = { padding: '6px 12px', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }
const label = { display: 'block', marginBottom: 6, fontSize: 13, color: '#666' }
const input = { width: '100%', padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 4, fontSize: 14, boxSizing: 'border-box' }
const modalOverlay = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }
const modalContent = { background: '#fff', borderRadius: 8, padding: 24, width: 480, maxHeight: '80vh', overflow: 'auto' }
